import { isPlatformBrowser } from '@angular/common'
import { PLATFORM_ID, inject } from '@angular/core'
import type {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router'
import { Router } from '@angular/router'

import { map } from 'rxjs'

import { AuthService } from '../services/auth/auth.service'

export const isAuthenticatedGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const platformId = inject(PLATFORM_ID)
  const router = inject(Router)
  const authService = inject(AuthService)

  if (!isPlatformBrowser(platformId)) {
    return true
  }

  return authService.waitForAuthCheckCompletion().pipe(
    map(() => {
      if (authService.isAuthenticated()) {
        return true
      }

      return router.createUrlTree(['/auth/login'], {
        queryParams: { returnUrl: state.url },
      })
    })
  )
}

export const isNotAuthenticatedGuard: CanActivateFn = () => {
  const platformId = inject(PLATFORM_ID)
  const router = inject(Router)
  const authService = inject(AuthService)

  if (!isPlatformBrowser(platformId)) {
    return true
  }

  return authService.waitForAuthCheckCompletion().pipe(
    map(() => {
      if (authService.isAuthenticated()) {
        return router.createUrlTree(['/'])
      }

      return true
    })
  )
}
